import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import PayableListPageUI from './PayableListPageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class PayableListPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            payable: null,
            copyToClipboardText: null,
            showDetails: false,
            selectedRowId: null,
            paySubmitted: false,
            paySuccessMsg: null,
            payErrorList: null,
            deleteSubmitted: false,
            deleteSuccessMsg: null,
            deleteErrorList: null,
        }
    }

    render() {
        return (
            <PayableListPageUI
                context={this.props.context}
                account={this.state.account}
                errorList={this.state.errorList}
                payable={this.state.payable}
                onRefreshClick={this.onRefreshClick}
                copyToClipboardText={this.state.copyToClipboardText}
                onCopyToClipboard={this.onCopyToClipboard}
                showDetails={this.state.showDetails}
                onShowDetails={this.onShowDetails}
                selectedRowId={this.state.selectedRowId}
                paySubmitted={this.state.paySubmitted}
                paySuccessMsg={this.state.paySuccessMsg}
                payErrorList={this.state.payErrorList}
                onPayClick={this.onPayClick}
                deleteSubmitted={this.state.deleteSubmitted}
                deleteSuccessMsg={this.state.deleteSuccessMsg}
                deleteErrorList={this.state.deleteErrorList}
                onDeleteClick={this.onDeleteClick}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getAccounts(context)
        this.getPayables(context)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.payableId == this.props.match.params.payableId)
            return

        let context = this.props.context
        this.getPayables(context)
    }

    getAccounts(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${this.props.match.params.accountId}`,
            cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
            callback: this.getAccountsCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getAccountsCallback = (response) => {
        this.setState({ account: response.account })
    }

    getPayables(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${this.props.match.params.accountId}/payables`,
            cacheKey: CacheKeys.Payables(this.props.match.params.accountId),
            callback: this.getPayablesCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getPayablesCallback = (response) => {
        this.setState({ payable: response.payable, errorList: response.errorList })
    }

    onCopyToClipboard = (text, result) => {
        this.setState({ copyToClipboardText: text })
        setTimeout(() => {
            this.setState({ copyToClipboardText: null })
        }, 3000)
    }

    onShowDetails = (event) => {
        let rowId = event.target.getAttribute('data-row-id')
        if (this.state.selectedRowId === rowId) {
            this.setState({
                showDetails: !this.state.showDetails,
            })
        }
        else {
            this.setState({
                showDetails: true,
                selectedRowId: rowId
            })
        }
    }

    onPayClick = (event) => {
        if (this.state.paySubmitted)
            return

        let rowId = event.target.getAttribute('data-row-id')
        this.setState({
            paySubmitted: true,
            payErrorList: [],
            selectedRowId: rowId
        })

        RestApiUtils.post(this.props.context,
            `/api/su/payables/${rowId}/payments`,
            this.onPayClickCallback, {}
        )
    }

    onPayClickCallback = (response) => {
        let errorList = []
        if (response.errorList.length) {
            response.errorList.forEach(error => {
                errorList.push(error.message)
            })
        }

        this.setState({
            paySuccessMsg: response.success,
            payErrorList: errorList,
            paySubmitted: false,
        })

        if (errorList.length === 0) {
            setTimeout(() => {
                this.setState({ paySuccessMsg: null, payErrorList: [] })
                this.onRefreshClick('noBusy')
            }, 10)
        }
    }

    onDeleteClick = (event) => {
        if (this.state.deleteSubmitted)
            return

        let rowId = event.target.getAttribute('data-row-id')
        this.setState({
            deleteSubmitted: true,
            deleteErrorList: [],
            selectedRowId: rowId
        })

        RestApiUtils.delete(this.props.context,
            `/api/su/payables/${rowId}`,
            this.onDeleteClickCallback, {}
        )
    }

    onDeleteClickCallback = (response) => {
        let errorList = []
        if (response.errorList.length) {
            response.errorList.forEach(error => {
                errorList.push(error.message)
            })
        }

        this.setState({
            deleteSuccessMsg: response.success,
            deleteErrorList: errorList,
            deleteSubmitted: false,
        })

        if (errorList.length === 0) {
            setTimeout(() => {
                this.setState({ deleteSuccessMsg: null, deleteErrorList: [] })
                this.onRefreshClick('noBusy')
            }, 2000)
        }
    }

    onRefreshClick = (noBusy) => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.Payables(this.props.match.params.accountId))
        if (noBusy === 'noBusy')
          this.getPayables(context)
        else
          this.setState({
              errorList: null,
              payable: null
            }, this.getPayables(context)
          )
    }

}

export default withRouter(PayableListPageSF)
